import { DocumentViewerDialog } from "@/domains/documents/components/DocumentViewerDialog";
import { ConfirmDialog } from "@/domains/documents/components/molecules/ConfirmDialog";
import { ChildDocumentsDialog } from "@/domains/documents/components/organisms/ChildDocumentsDialog";
import { observer } from "mobx-react-lite";
import type { DocumentTablePresentation } from "./documentTablePresentation";
export const TableDeleteDialog = observer(function TableDeleteDialog(
  props: DocumentTablePresentation
) {
  const { deleteConfirmState, setDeleteConfirmState, isRestore, t, executeDelete } = props;
  return (
    <ConfirmDialog
      open={deleteConfirmState.open}
      onOpenChange={(open) => setDeleteConfirmState({ open, docId: null, filename: null })}
      title={
        isRestore ? t.documents.trash.restoreDocumentTitle : t.documents.actions.deleteDocumentTitle
      }
      description={
        isRestore
          ? deleteConfirmState.filename
            ? t.documents.trash.restoreDocumentConfirm.replace(
                "{filename}",
                deleteConfirmState.filename
              )
            : t.documents.trash.restoreDocumentConfirmFallback
          : deleteConfirmState.filename
            ? t.documents.actions.deleteDocumentConfirm.replace(
                "{filename}",
                deleteConfirmState.filename
              )
            : t.documents.actions.deleteDocumentConfirmFallback
      }
      onConfirm={executeDelete}
      confirmLabel={isRestore ? t.documents.trash.restore : t.common.delete}
      variant={isRestore ? "default" : "destructive"}
    />
  );
});

export const TableViewerDialog = observer(function TableViewerDialog(
  props: DocumentTablePresentation
) {
  const {
    previewReturnFocusRef,
    previewDocument,
    previewBlobUrl,
    previewBlobData,
    previewOpen,
    originalDwgFilePath,
    setPreviewOpen,
    setPreviewBlobUrl,
    setPreviewBlobData,
    setPreviewDocument,
    setOriginalDwgFilePath,
  } = props;
  return (
    <DocumentViewerDialog
      focusReturnTarget={previewReturnFocusRef.current}
      document={previewDocument}
      blobUrl={previewBlobUrl}
      blobData={previewBlobData}
      open={previewOpen}
      originalDwgFilePath={originalDwgFilePath ?? undefined}
      onOpenChange={(open) => {
        setPreviewOpen(open);
        if (!open && previewBlobUrl) {
          // Revoke blob URL when closing
          URL.revokeObjectURL(previewBlobUrl);
          setPreviewBlobUrl(null);
          setPreviewBlobData(null);
          setPreviewDocument(null);
          setOriginalDwgFilePath(null);
        }
      }}
    />
  );
});

export const TableChildrenDialog = observer(function TableChildrenDialog(
  props: DocumentTablePresentation
) {
  const {
    childModalDocId,
    childModalFilename,
    buildingId,
    store,
    setChildModalDocId,
    setChildModalFilename,
  } = props;
  return (
    <ChildDocumentsDialog
      parentDocumentId={childModalDocId}
      parentFilename={childModalFilename}
      buildingId={buildingId}
      store={store}
      onOpenChange={(open) => {
        if (!open) {
          setChildModalDocId(null);
          setChildModalFilename("");
        }
      }}
    />
  );
});
